import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'm-upload-page',
  template: `
    <div class="m-upload-page">
      <div class="m-upload-page-header" [ngStyle]="{ 'background-image': 'url(' + mBgSrc + ')', 'background-color': mBgColor }">
        <p class="name">{{ mTitle }}</p>
      </div>
      <div class="m-upload-page-body">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  host: {
    class: 'm-upload-page'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MUploadPageComponent {
  @Input() mTitle = '';
  @Input() mBgSrc = '';
  @Input() mBgColor = '#fff';
}
